import { IBusinessConfigs } from '../_Common/Const/BusinessConfigs';
import { initConst } from '../../../Utils/utils';

const PUBusinessConfig = initConst<IBusinessConfigs>(() => ({
  PUProgramAndring: {
    defaultColumns: [
      { attributeDef: 'UPPG_NR', caption: 'Uppg.nr.' },
      { attributeDef: 'SUBSYSTEM', caption: 'Delsystem' },
      { attributeDef: 'RutinNamn', caption: 'Rutinnamn' },
      { attributeDef: 'TITEL', caption: 'Titel' },
      { attributeDef: 'STATUS', caption: 'Status' },
      { attributeDef: 'PRIORITET', caption: 'Prioritet' },
      { attributeDef: 'Ansvarig_Sign', caption: 'Ansvarig prog' },
      { attributeDef: 'SpecasAv', caption: 'Ansvarig spec' },
      { attributeDef: 'TID_KVAR', caption: 'Kvar, prog' },
      { attributeDef: 'TID_KVAR_SPEC', caption: 'Kvar, spec/dok' },
      { attributeDef: 'TotalTidKvar', caption: 'Kvar, totalt' },
      { attributeDef: 'SENAST_GRANSKAD', caption: 'Kontrollerad, datum' },
      {
        attributeDef: 'SENAST_GRANSKAD_SIGN',
        caption: 'Kontrollerad, signatur',
      },
      {
        attributeDef: 'SENAST_GRANSKAD_NOTERING',
        caption: 'Kontrollerad, notering',
      },
      { attributeDef: 'FORESLAGEN_VERSION', caption: 'Föresl ver' },
      { attributeDef: 'Huvuduppgift.TITEL', caption: 'Huvuduppgift' },
      { attributeDef: 'HUVUDUPPG_NR', caption: 'Huvuduppg, nr' },
      { attributeDef: 'KATEGORI', caption: 'Kategori' },
      { attributeDef: 'SENAST_DATUM', caption: 'Klart senast' },
      { attributeDef: 'UPPFOLJN_KOD', caption: 'Uppföljning' },
      { attributeDef: 'RegistreratAv_Sign', caption: 'Registrerat av' },
    ],
  },
  PUFAQ: {
    defaultColumns: [
      { attributeDef: 'SUBSYSTEM', caption: 'Delprogram' },
      { attributeDef: 'RutinNamn', caption: 'Rutinnamn' },
      { attributeDef: 'FRAGA', caption: 'Fråga' },
      { attributeDef: 'INTERN', caption: 'Intern' },
    ],
  },
  PUUppdatering: {
    defaultColumns: [
      { attributeDef: 'VERSION', caption: 'Version' },
      { attributeDef: 'BENAMNING', caption: 'Benämning' },
      { attributeDef: 'klar', caption: 'Klar' },
      { attributeDef: 'NOTERING', caption: 'Notering' },
    ],
  },
}));

export default PUBusinessConfig;
